import React from 'react';
import * as d3 from 'd3';

export default class DraggableBarChart extends React.Component {

    div = null;
    svg = null;
    focus = null;
    drag = null;
    zoom = null;

    svgWidth = 800;
    svgHeight = 400;

    margin = { top: 10, right: 20, bottom: 30, left: 50 };
    width = this.svgWidth - this.margin.left - this.margin.right;
    height = this.svgHeight - this.margin.top - this.margin.bottom;

    x = null;
    y = null;

    minX = -50;
    maxX = 100;
    minY = 0;
    maxY = 110;

    xAxis = null;
    yAxis = null;

    area = null;
    line = null;

    start_x = null;
    start_y = null;
    start_screen_x = null;
    start_screen_y = null;

    isMouseOver = false;

    constructor(props) {
        super(props);

        this.state = {
            data: this.props.properties
        };

        this.handleChange = this.handleChange.bind(this);

        this.onDragStarted = this.onDragStarted.bind(this);
        this.onDragged = this.onDragged.bind(this);
        this.onDragEnded = this.onDragEnded.bind(this);

        this.onMouseOver = this.onMouseOver.bind(this);
        this.onMouseOut = this.onMouseOut.bind(this);

        this.onZoom = this.onZoom.bind(this)
    }

    handleChange(e) {
        const value = e.target.value;
        this.props.handleChange(e.target.name, value);
    }

    drawAreaChart() {

        const data = this.props.properties;
        let dataChart = [
            { x: this.minX, y: 100, draggable: false },
            { y: 100, draggable: true },
            { draggable: true },
            { x: this.maxX, draggable: false }
        ];

        const yLabelOffset = 10;
        const xLabelOffset = 20;

        // Get X's and Y's from props
        Object.keys(data).sort().forEach((key) => {
            if (data[key].info.name === 'dg.dl') {
                dataChart[2].y = data[key].valueMeta.default;
                dataChart[3].y = data[key].valueMeta.default;
            } else if (data[key].info.name === 'dg.pre') {
                dataChart[1].x = data[key].value;
                dataChart[2].x = data[key].value;
            } else if (data[key].info.name === 'dgps.en') {
                dataChart[2].y = '0';
                dataChart[3].y = '0';
                dataChart[1].x = '0';
                dataChart[2].x = '0';
                if(this.props.disabled){
                    dataChart[2].y = '55';
                    dataChart[3].y = '55';
                }
            }
        });

        // -------------
        // Add X axis
        this.x.domain([this.minX, this.maxX]);

        // Add Y axis
        this.y.domain([this.minY, this.maxY]);

        // Fill the area
        this.svg.append("path")
            .datum(dataChart)
            .attr("class", "area-dark")
            .attr("stroke", "none")
            .attr("d", this.area);

        // add gradient
        this.svg.append("linearGradient")
            .attr("id", "area-gradient-dark")
            .attr("gradientUnits", "userSpaceOnUse")
            .attr("x1", 0).attr("y1", this.y(0))
            .attr("x2", 0).attr("y2", this.y(this.maxY))
            .selectAll("stop")
            .data([
                { offset: "0%", color: "#fdcfa1" },
                { offset: "100%", color: "#E95B0D" }
            ])
            .enter().append("stop")
            .attr("offset", function (d) { return d.offset; })
            .attr("stop-color", function (d) { return d.color; });

        // add the line
        this.svg.append("path")
            .datum(dataChart)
            .attr("class", "line")
            .attr("fill", "none")
            .attr("stroke", "black")
            .attr("stroke-width", 1)
            .attr("d", this.line);

        // Add the Circles
        // this.svg.selectAll("circle")
        //     .data(dataChart)
        //     .enter()
        //     .append('circle')
        //     .attr('r', 5.0)
        //     .attr("cx", (d) =>  { return this.x(d.x) })
        //     .attr("cy", (d) =>  { return this.y(d.y) })
        //     .style('cursor', 'pointer')
        //     .style('fill', 'white')
        //     .attr("stroke", "black")
        //     .attr("stroke-width", 1)
        //     .on("mouseover", this.onMouseOver)
        //     .on("mouseout", this.onMouseOut)
        //     .call(this.drag);

        // Add the x axis
        this.svg.append("g")
            .attr('class', 'axis axis--x')
            .attr("transform", "translate(0," + this.height + ")")
            .call(this.xAxis);

        if (this.props.xLabels) {
            for (let i = 0; i < this.props.xLabels.labels.length; i++) {
                const el = this.props.xLabels.labels[i];
                this.svg.append("text")
                    .attr("x", this.x(el.x))
                    .attr("y", this.y(this.minY) + xLabelOffset)
                    .text(el.label)
                    .attr("text-anchor", "middle")
                    .attr("alignment-baseline", "top")
                    .attr("font-size", "0.7rem");
            }
            for (let i = 0; i < this.props.xLabels.smallLabels.length; i++) {
                const el = this.props.xLabels.smallLabels[i];
                this.svg.append("text")
                    .attr("x", this.x(el.x))
                    .attr("y", this.y(this.minY) + xLabelOffset / 1.75)
                    .text(el.label)
                    .attr("text-anchor", "middle")
                    .attr("alignment-baseline", "top")
                    .attr("font-size", "0.6rem");
            }
            for (let i = 0; i < this.props.xLabels.ticks.length; i++) {
                const el = this.props.xLabels.ticks[i];
                this.svg.append("line")
                    .attr("x1", this.x(el))
                    .attr("y1", this.y(this.minY))
                    .attr("x2", this.x(el))
                    .attr("y2", this.y(this.minY) + yLabelOffset / 1.75)
                    .style("stroke", "rgb(0,0,0)");

            }
        }

        // Add the y axis
        this.svg.append("g")
            .attr('class', 'axis axis--y')
            .call(this.yAxis);

        if (this.props.xThresholds) {

            for (let i = 0; i < this.props.xThresholds.length; i++) {
                this.svg.append("line")
                    .attr("x1", this.x((this.props.xThresholds[i].value)))
                    .attr("y1", this.y(this.minY))
                    .attr("x2", this.x((this.props.xThresholds[i].value)))
                    .attr("y2", this.y(this.maxY))
                    .style("stroke-dasharray", "5,5")
                    .style("stroke", this.props.xThresholds[i].color);
            }
        }

        if (this.props.yLabels) {
            for (let i = 0; i < this.props.yLabels.length; i++) {
                this.svg.append("line")
                    .attr("x1", this.x(this.minX))
                    .attr("y1", this.y(this.props.yLabels[i].y))
                    .attr("x2", this.x(this.minX) - yLabelOffset / 2)
                    .attr("y2", this.y(this.props.yLabels[i].y))
                    .style("stroke", "rgb(0,0,0)");
                this.svg.append("text")
                    .attr("x", this.x(this.minX) - yLabelOffset)
                    .attr("y", this.y(this.props.yLabels[i].y))
                    .text(this.props.yLabels[i].label)
                    .attr("text-anchor", "end")
                    .attr("alignment-baseline", "middle");
            }
        }

    }

    onMouseOver(d, i, array) {
        d3.select(array[i]).style("cursor", "move");

        this.div.transition()
            .duration(200)
            .style("opacity", .9);
        this.div.html(`${this.props.x.title}: ${d.x}</br>${this.props.y.title}: ${d.y}`)
            .style("left", (d3.event.pageX - 140) + "px")
            .style("top", (d3.event.pageY - 50) + "px");
    }

    onMouseOut(d, i, array) {
        this.div.transition()
            .duration(500)
            .style("opacity", 0);
    }

    onDragStarted(d, i, array) {
        if (!d.draggable) {
            return;
        }
        d3.select(array[i]).raise().classed('active', true);

        this.start_x = +d3.event.x;
        this.start_y = +d3.event.y;
        this.start_screen_x = +d3.event.sourceEvent.screenX;
        this.start_screen_y = +d3.event.sourceEvent.screenY;
    }

    onDragged(d, i, array) {

        if (!d.draggable) {
            return;
        }

        const changedX = d3.event.sourceEvent.screenX - this.start_screen_x;
        // const changedY = this.start_screen_y - d3.event.sourceEvent.screenY;

        // let current_scale = 1;
        // if (array[i].getAttribute("transform") === null)
        // {
        //     current_scale = 1;
        // }
        // else {
        //     const current_scale_string = this.getAttribute("transform").split(' ')[1];
        //     current_scale = +current_scale_string.substring(6,current_scale_string.length-1);
        // }

        // d['x'] = Math.round(this.x.invert(this.x(this.start_x) + changedX) / current_scale);
        // d['y'] = Math.round(this.y.invert(this.y(this.start_y) - changedY) / current_scale);

        d['x'] = Math.round(this.x.invert(this.x(this.start_x) + changedX));
        //d['y'] = Math.round(this.y.invert(this.y(this.start_y) - changedY));

        if (d.x > 0) {
            d.x = 0;
        } else if (d.x < -20) {
            d.x = -20;
        }

        d3.select(array[1]).attr('cx', this.x(d.x));
        d3.select(array[2]).attr('cx', this.x(d.x));

        this.svg.select('path.area').attr('d', this.area);
        this.svg.select('path.line').attr('d', this.line);
    }

    onDragEnded(d, i, array) {
        if (!d.draggable) {
            return;
        }
        d3.select(array[i]).classed('active', false);

        this.start_x = null;
        this.start_y = null;

        this.start_screen_x = null;
        this.start_screen_y = null;

        this.props.handleChange(d, i);
    }

    onZoom(d) {
        this.svg.attr("transform", d3.event.transform);
    }

    initializeChart() {

        // get div for tooltip
        this.div = d3.select("body").append("div")
            .attr("class", "tooltip")
            .style("opacity", 0);

        // get svg
        this.svg = d3.select("#area");

        // get x scale
        this.x = d3.scaleLinear()
            .rangeRound([0, this.width]);

        // get y scale
        this.y = d3.scaleLinear()
            .rangeRound([this.height, 0]);

        // get x axis
        this.xAxis = d3.axisBottom(this.x);
        if (this.props.tickValues && this.props.tickValues.x) {
            this.xAxis = this.xAxis.tickValues(this.props.tickValues.x);
        }

        // get y axis
        this.yAxis = d3.axisLeft(this.y);
        if (this.props.tickValues && this.props.tickValues.y) {
            this.yAxis = this.yAxis.tickValues(this.props.tickValues.y);
        }

        // text label for the x axis
        this.svg.append("text")
            .attr("transform", "translate(" + (this.width / 2) + " ," + (this.svgHeight + 10) + ")")
            .style("text-anchor", "middle")
            .text(this.props.x.title);

        // text label for the y axis
        this.svg.append("text")
            .attr("transform", "")
            .attr("transform", "translate(" + this.margin.right + "," + (this.svgHeight / 2) + ") rotate(-90)")
            .style("text-anchor", "middle")
            .text(this.props.y.title);

        // Area
        this.area = d3.area()
            .x((d) => { return this.x(d.x) })
            .y0(this.y(0))
            .y1((d) => { return this.y(d.y) });

        // Line
        this.line = d3.line()
            .x((d) => { return this.x(d.x) })
            .y((d) => { return this.y(d.y) });

        // !! d3 v5-era code, NOT converted for v7 !!
        //
        // Neither behaviour is attached: `.call(this.drag)` is commented out above and
        // nothing in the repo calls `.call(this.zoom)`, so the handlers below never run.
        // That is why the v5 -> v7 bump was safe — no live code reads the removed
        // `d3.event`.
        //
        // Before re-enabling any of this, the handlers MUST be converted, or they will
        // throw. In v6+ a listener receives the event as its FIRST argument and the old
        // (d, i, array) signature is gone:
        //
        //   onDragStarted(d, i, array)      ->  onDragStarted(event, d)
        //   d3.event.x / .sourceEvent       ->  event.x / event.sourceEvent
        //   d3.event.transform  (onZoom)    ->  event.transform
        //   d3.event.pageX      (tooltips)  ->  event.pageX
        //   d3.select(array[i])             ->  d3.select(event.currentTarget)
        //
        // Left unconverted deliberately: dead code cannot be tested, and rewriting it
        // blind during a dependency bump would ship unverifiable behaviour.

        // Add drag
        this.drag = d3.drag()
        // .on('start', this.onDragStarted)
        // .on('drag', this.onDragged)
        // .on('end', this.onDragEnded);

        // Add zoom
        this.zoom = d3.zoom()
            .on("zoom", this.onZoom);

        // this.svg.append('rect')
        //     .attr('class', 'zoom')
        //     .attr('cursor', 'move')
        //     .attr('fill', 'none')
        //     .attr('pointer-events', 'all')
        //     .attr('width', this.width)
        //     .attr('height', this.height)
        //     .attr('transform', 'translate(' + this.margin.left + ',' + this.margin.top + ')');

        // better translation
        this.svg = this.svg.append("g")
            .attr("transform", "translate(" + this.margin.left + "," + this.margin.top + ")");

    }

    componentDidUpdate() {

        const chart = document.getElementById('area');
        while (chart.hasChildNodes()) {
            chart.removeChild(chart.lastChild);
        }

        this.div.transition()
            .style("opacity", 0);

        this.initializeChart();

        if (!this.props.containsErrors) {
            this.drawAreaChart();
        } else {
            this.initializeChart();
        }
    }

    componentDidMount() {
        this.initializeChart();
        if (!this.props.containsErrors) {
            this.drawAreaChart();
        } else {
            this.initializeChart();
        }
    }

    render() {

        return (
            <svg id="area"
                onChange={this.handleChange}
                width={this.svgWidth}
                height={this.svgHeight + 20}
                className={this.props.disabled ? "center disabled" : "center"}>
            </svg>
        );
    }
}
